import { createRootRouteWithContext, Navigate, Outlet } from '@tanstack/react-router'
import { MercatusRouterContext } from '@shared/router/MercatusRouterContext'

export const Route = createRootRouteWithContext<MercatusRouterContext>()({
  component: RootComponent,
  notFoundComponent: RootNotFoundComponent,
})

function RootComponent() {
  return <Outlet />
}

function RootNotFoundComponent() {
  return <Navigate to="/404" replace />
}
